export const getProductId = (item, index = 0) => {
  return (
    item?.product_id ??
    item?.product_listing_id ??
    item?.barcode ??
    item?.bar_code ??
    `size-${index}`
  );
};

export const getProductListingId = (item) => {
  return Number(
    item?.product_listing_id ??
    item?.product_id ??
    0
  );
};

export const getStock = (item) => {
  return Number(
    item?.avail_stock ??
    item?.available_stock ??
    item?.stock ??
    0
  );
};

export const getSizeName = (item) => {
  return (
    item?.size ??
    item?.size_name ??
    item?.sizeName ??
    item?.name ??
    "-"
  );
};

export const getBarcode = (item) => {
  return (
    item?.barcode ??
    item?.bar_code ??
    item?.barcode_number ??
    ""
  );
};

export const getPrice = (item) => {
  return (
    item?.price ??
    item?.selling_price ??
    item?.sale_price ??
    item?.mrp ??
    0
  );
};
